export default "__VITE_ASSET__2e3f5f5d__"